//export const apiURL = "http://192.168.100.105:8000/api/";
//export const apiURL = "http://localhost:8000/api/";
export const apiURL = "https://aps-api.nditakure.co.zw/api/";
